import React from 'react';
import './Exhibitiontable.css';



const Exhibitiontable = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Disha Injection Molding Production Case</h2>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Product</strong> </p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Cycle Time	</strong></p>
                    <p><strong>Material</strong></p>
                </div>
                <div className="right-column">
                    <p>PET600-S6</p>
                    <p>Plastic Fruit Bowls</p>
                    <p>273g</p>
                    <p>30s</p>
                    <p>PET</p>
                </div>
            </div>
        </div>
    );
};

export default Exhibitiontable;
